import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box
} from '@material-ui/core';
import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { createStaff, updateStaff } from 'src/store/actions/StaffActions';
import { issuerModules, modules } from 'src/utils/utils';

function CreateStaff({ handleClose, modalData }) {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async (values) => {
    setLoading(true);
    const response = !modalData
      ? await dispatch(createStaff(values, profile))
      : await dispatch(updateStaff(modalData.id, values, profile));
    setLoading(false);
    if (response.status === 1) handleClose();
  };

  return (
    <Formik
      initialValues={{
        fullname: `${modalData?.fullname || ''}`,
        username: `${modalData?.username || ''}`,
        phone: `${modalData?.phone || ''}`,
        email: '',
        address: '',
        password: '',
        priviledges: modalData?.priviledges
          ? JSON.parse(modalData?.priviledges)
          : []
      }}
      validationSchema={Yup.object().shape({
        fullname: Yup.string().trim().max(255).required('Fullname is required'),
        username: Yup.string().trim().max(255).required('Username is required'),
        phone: Yup.number().required('Phone number is required')
      })}
      onSubmit={(values) => {
        handleSubmit(values);
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values,
        setFieldValue
      }) => {
        const userModules = profile?.super === 1 ? modules : issuerModules;

        return (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs="6">
                  <TextField
                    error={Boolean(touched.fullname && errors.fullname)}
                    fullWidth
                    helperText={touched.fullname && errors.fullname}
                    label="Fullname"
                    margin="dense"
                    name="fullname"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.fullname}
                    variant="outlined"
                    size="small"
                  />
                </Grid>

                {!modalData && (
                  <Grid item xs="6">
                    <TextField
                      error={Boolean(touched.email && errors.email)}
                      fullWidth
                      helperText={touched.email && errors.email}
                      label="Email Address"
                      margin="dense"
                      name="email"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="text"
                      value={values.email}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                )}

                <Grid item xs="6">
                  <TextField
                    error={Boolean(touched.phone && errors.phone)}
                    fullWidth
                    helperText={touched.phone && errors.phone}
                    label="Phone number"
                    margin="dense"
                    name="phone"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.phone}
                    variant="outlined"
                    size="small"
                  />
                </Grid>

                {!modalData && (
                  <Grid item xs="6">
                    <TextField
                      error={Boolean(touched.address && errors.address)}
                      fullWidth
                      helperText={touched.address && errors.address}
                      label="Address"
                      margin="dense"
                      name="address"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="text"
                      value={values.address}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                )}

                <Grid item xs="6">
                  <TextField
                    error={Boolean(touched.username && errors.username)}
                    fullWidth
                    helperText={touched.username && errors.username}
                    label="Username"
                    margin="dense"
                    name="username"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.username}
                    variant="outlined"
                    size="small"
                  />
                </Grid>

                {!modalData && (
                  <Grid item xs="6">
                    <TextField
                      error={Boolean(touched.password && errors.password)}
                      fullWidth
                      helperText={touched.password && errors.password}
                      label="Password"
                      margin="dense"
                      name="password"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type="password"
                      value={values.password}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                )}
              </Grid>

              <Grid item lg={12}>
                <FormControl component="fieldset">
                  {/* <FormLabel component="legend">Assign your preferred routes to show this Ad</FormLabel> */}
                  <Box direction="row" marginY={2}>
                    <Typography color="textPrimary" variant="h4">
                      Assign Module Priviledges
                    </Typography>
                    <FormGroup style={{ border: 1 }}>
                      {userModules.map((module) => (
                        <FormControlLabel
                          key={module.id}
                          control={
                            <Checkbox
                              checked={values.priviledges.includes(
                                module.value.toString()
                              )}
                              onChange={(e) => {
                                const { checked, name } = e.target;
                                if (checked) {
                                  setFieldValue('priviledges', [
                                    ...values.priviledges,
                                    name
                                  ]);
                                } else {
                                  setFieldValue(
                                    'priviledges',
                                    values.priviledges.filter((v) => v !== name)
                                  );
                                }
                              }}
                              name={module.value.toString()}
                              id={module.value.toString()}
                            />
                          }
                          label={module.name}
                        />
                      ))}
                    </FormGroup>
                  </Box>
                </FormControl>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={handleClose}>
                Close
              </Button>
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                type="submit"
              >
                {loading && <CircularProgress size="1.5rem" />}
                Submit
              </Button>
            </DialogActions>
          </form>
        );
      }}
    </Formik>
  );
}

export default CreateStaff;
